import React from 'react';
import { Link } from 'react-router-dom';

function getReferenceProfileId(reference) {
  if (!reference || typeof reference !== 'object') {
    return '';
  }

  const type = String(reference.type || '').trim().toLowerCase();
  const id = String(reference.id || '').trim();

  return type === 'profile' && id ? id : '';
}

function SystemEventReferenceValue({ reference, label }) {
  const value = label || '-';
  const profileId = getReferenceProfileId(reference);

  if (!profileId) {
    return value;
  }

  return (
    <Link to={`/profiles/${encodeURIComponent(profileId)}`} className="text-decoration-none text-break">
      {value}
      <i className="ti ti-external-link ms-1" aria-hidden="true" />
    </Link>
  );
}

export default SystemEventReferenceValue;
